const onChangeInput = (e, $this) => {
    $this.setState({
        ...$this.state,
        form : {
            ...$this.state.form,
            [e.target.name]: e.target.value
        }
    });
}

const onChangeCheckbox = (e, $this) => {
    $this.setState({
        ...$this.state,
        form: {
            ...$this.state.form,
            [e.target.name]: e.target.checked
        }
    });
};

const onSelectBasic = (e, $this) => {
    $this.setState({
        ...$this.state,
        form: {
            ...$this.state.form,
            [e.target.name]: e.target.value === "null" ? null : e.target.value
        }
    })
}

const onSelectJson = (e, $this) => {
    e.preventDefault();
    const json = JSON.parse(e.target.value);
    $this.setState({
        ...$this.state,
        form: {
            ...$this.state.form,
            [e.target.name]: json
        }
    });
}

const onChangeStateKey = (data, key, $this) => {
    $this.setState({
        ...$this.state,
        form: {...$this.state.form, [key]: data}
    })
}

export const FormHandler = {
    onChangeInput,
    onChangeCheckbox,
    onSelectBasic,
    onSelectJson,
    onChangeStateKey
}
